import styled from 'styled-components';
import { roleMap } from '../../Alert/Alert.js';
import { LinkButton } from '../../LinkButton/LinkButton.js';
import { jsx, jsxs } from 'react/jsx-runtime';

var CTAWrapper = styled.div.withConfig({
  displayName: "BannerText__CTAWrapper",
  componentId: "sc-lbfikk-0"
})(["&&{display:inline;padding-inline-start:8px;}"]);
var BannerTextContainer = styled.div.withConfig({
  displayName: "BannerText__BannerTextContainer",
  componentId: "sc-lbfikk-1"
})(["&&{display:flex;align-items:center;}"]);
var BannerText = function BannerText(props) {
  var CTA = props.CTA,
    html = props.html,
    message = props.message,
    _props$variant = props.variant,
    variant = _props$variant === void 0 ? "info" : _props$variant;
  function renderCTA() {
    if (!CTA) {
      return null;
    }
    if ("children" in CTA) {
      return CTA.children;
    }
    if ("href" in CTA) {
      return /*#__PURE__*/jsx("a", {
        className: "mntl-secondary",
        onClick: CTA.onClick,
        href: CTA.href,
        children: CTA.label
      });
    }
    return /*#__PURE__*/jsx(LinkButton, {
      label: CTA.label,
      onClick: CTA.onClick,
      variant: "secondary"
    });
  }
  if (html) {
    return /*#__PURE__*/jsx("span", {
      "aria-atomic": true,
      role: roleMap[variant],
      dangerouslySetInnerHTML: {
        __html: html
      }
    });
  }
  return /*#__PURE__*/jsxs(BannerTextContainer, {
    children: [message && /*#__PURE__*/jsx("span", {
      "aria-atomic": true,
      role: roleMap[variant],
      children: message
    }), CTA && /*#__PURE__*/jsx(CTAWrapper, {
      children: renderCTA()
    })]
  });
};
BannerText.displayName = "BannerText";

export { BannerText };
